import inventoryReducer from "./reducers";

export default inventoryReducer;
